import { getAvatarColor } from '@/utils/colors';
export function mapGroups(groups: any) {
  if (!(groups && groups.length > 0)) {
    return [
      {
        isCreated: false,
        name: '',
        members: []
      }
    ];
  }
  const formatted = groups.map((group: any) => {
    if (!(Array.isArray(group.members) && group.members.length > 0)) {
      return group;
    }
    const members = mapTeamMembers(group.members);
    return {
      ...group,
      avatarColor: group.avatarColor || getAvatarColor(),
      avatarName: group.avatarName || `${group.name.length > 0 ? group.name[0] : ''}`,
      isCreated: group.isCreated || false,
      members
    };
  });
  return formatted;
}

export function mapTeamMembers(members: any) {
  const membersFormatted = members.map((item: any) => {
    if (!item.avatarColor) {
      item.avatarColor = getAvatarColor();
    }
    return {
      ...item,
      avatarColor: item.avatarColor || getAvatarColor(),
      avatarName: item.firstName.charAt(0) + item.lastName.charAt(0),
      name: `${item.firstName} ${item.lastName}`
    };
  });
  return membersFormatted;
}
